import styled from "styled-components";

export const CorperateEmailSettingContainerStyled = styled.div`
  margin-top: 20px;
  border-radius: 1rem;
  padding: 1.25rem;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
`;
